/**
 * * DMY - dd.mm.yyyy
 * * MDY - mm.dd.yyyy
 * * YMD - yyyy.mm.dd
 */
export type PrizmDateMode = 'DMY' | 'MDY' | 'YMD';
